import { connect } from 'react-redux';
import { FontSizes, Label, Separator } from '@fluentui/react';
import SettlementMoneyChartComponent from '../SettlementMoneyChart/SettlementMoneyChart.Component';
import { CharType } from '../SettlementMoneyChart/SettlementMoneyChart.Functions';

// functions
import * as ComponentFunctions from './SettlementTotalItem.Functions';
import { Subtitle2 } from '@fluentui/react-components';

// styles
import './SettlementTotalItem.Styles.css';


//i18Next
//import { useTranslation } from 'react-i18next';

const SettlementTotalItemComponent = (props: ComponentFunctions.Props) => {

    //useTranslation()
    //const [t] = useTranslation();

    return (
        <>
            {/* <Label>{t('settlementTotal.total')}</Label> */}
            <Label style={{ fontSize: FontSizes.size24 }}>{(props.OwnerAmount || 0)?.toLocaleString('es-AR', { style: 'currency', currency: props.CurrencyCode?.toUpperCase() }) || '0.00'}</Label>
            <Separator />
            <Subtitle2>Detalle</Subtitle2>
            {(props.TotalToSettle && props.TotalToSettle > 0) ?
                <div className='SettlementTotalContainer'>
                    <div>
                        <Label style={{ fontSize: FontSizes.size12 }}>Total a liquidar</Label>
                        <Label style={{ fontSize: FontSizes.size16 }}>{(props.TotalToSettle || 0)?.toLocaleString('es-AR', { style: 'currency', currency: props.CurrencyCode?.toUpperCase() }) || '0.00'}</Label>
                    </div>
                    <div>
                        <Label style={{ fontSize: FontSizes.size12 }}>Total a retener</Label>
                        <Label style={{ fontSize: FontSizes.size16 }}>{(props.TotalWithholdings || 0)?.toLocaleString('es-AR', { style: 'currency', currency: props.CurrencyCode?.toUpperCase() }) || '0.00'}</Label>
                    </div>
                    <div>
                        <Label style={{ fontSize: FontSizes.size12 }}>Total Centro</Label>
                        <Label style={{ fontSize: FontSizes.size16 }}>{(props.OwnerAmount || 0)?.toLocaleString('es-AR', { style: 'currency', currency: props.CurrencyCode?.toUpperCase() }) || '0.00'}</Label>
                    </div>
                    <div>
                        <Label style={{ fontSize: FontSizes.size12 }}>Total a retener Centro</Label>
                        <Label style={{ fontSize: FontSizes.size16 }}>{(props.OwnerWithholdings || 0)?.toLocaleString('es-AR', { style: 'currency', currency: props.CurrencyCode?.toUpperCase() }) || '0.00'}</Label>
                    </div>
                    <div>
                        <Label style={{ fontSize: FontSizes.size12 }}>Total Equipo Médico</Label>
                        <Label style={{ fontSize: FontSizes.size16 }}>{(props.TeamAmount || 0)?.toLocaleString('es-AR', { style: 'currency', currency: props.CurrencyCode?.toUpperCase() }) || '0.00'}</Label>
                    </div>
                    <div>
                        <Label style={{ fontSize: FontSizes.size12 }}>Total a retener Equipo Médico</Label>
                        <Label style={{ fontSize: FontSizes.size16 }}>{(props.TeamWithholdings || 0)?.toLocaleString('es-AR', { style: 'currency', currency: props.CurrencyCode?.toUpperCase() }) || '0.00'}</Label>
                    </div>
                    <small>Estadísticas</small>
                    <p>
                        <SettlementMoneyChartComponent SettlementId={props.SettlementId} CurrencyCode={props.CurrencyCode} ChartType={CharType.Donut} />
                    </p>
                </div>
                : null}

        </>);

};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(SettlementTotalItemComponent as any);